// ==============================|| DEFAULT THEME - TYPOGRAPHY - MODERN ||============================== //

export default function Typography(fontFamily) {
  return {
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    fontWeightSemiBold: 700,
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      lineHeight: 1.2,
      letterSpacing: '-0.02em'
    },
    h2: {
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.25,
      letterSpacing: '-0.01em'
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: 1.33,
      letterSpacing: '-0.005em'
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.4
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.5
    },
    h6: {
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.57,
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    caption: {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66,
      color: '#6b7280'
    },
    body1: {
      fontSize: '0.95rem',
      lineHeight: 1.6,
      color: '#374151'
    },
    body2: {
      fontSize: '0.85rem',
      lineHeight: 1.57,
      color: '#6b7280'
    },
    subtitle1: {
      fontSize: '0.95rem',
      fontWeight: 600,
      lineHeight: 1.57,
      color: '#1f2937'
    },
    subtitle2: {
      fontSize: '0.85rem',
      fontWeight: 500,
      lineHeight: 1.66,
      color: '#6b7280'
    },
    overline: {
      lineHeight: 1.66,
      textTransform: 'capitalize',
      fontWeight: 600,
      fontSize: '0.75rem',
      color: '#9ca3af'
    },
    button: {
      textTransform: 'capitalize',
      fontWeight: 600,
      fontSize: '0.9375rem'
    }
  };
}
